import ApiService from 'app/services/ApiService';

export const FRONT_BEGIN = 'FRONT_BEGIN';
export const FRONT_SUCCESS = 'FRONT_SUCCESS';
export const FRONT_FAILURE = 'FRONT_FAILURE';
export const CLEAR_FRONT = 'CLEAR_FRONT';

export function fetchFront() {
    return async dispatch => {
        dispatch(frontBegin());
        await ApiService.getFronts()
            .then(
                result => {
                    dispatch(frontAdd(result));
                },
                error => {
                    dispatch(frontError());
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const frontBegin = () => ({
    type: FRONT_BEGIN,
});

export const frontAdd = data => ({
    type: FRONT_SUCCESS,
    payload: { data }
})

export const frontError = () => ({
    type: FRONT_FAILURE,
})

export const clearFront = () => ({
    type: CLEAR_FRONT,
});